/* PackageEditorExportTabRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const Terminal = require("../../../../widgets/terminal/TerminalComponent");
class PackageEditorExportTabRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("package-editor-export-tab-gl");
        this._rootElem.component = this._model;

        this._contentElem = undefined;
        this._terminal = new Terminal();
        this._footerElem = undefined;
        this.exportBtn = undefined;

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            this._contentElem = undefined;
            this._terminal.shutdown();
            this._terminal = undefined;
            this._footerElem = undefined;
            this.exportBtn = undefined;
            resolve();
        });
    }
    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
        this._model.on("ResizeContainer", (this._onResizeEvent = this._onResizeEvent.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
        this._model.removeListener("ResizeContainer", this._onResizeEvent);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let contentProm = this._renderContent();
        this._renderFooter();
        if (!this._rootElem.hasChildNodes()) {
            this._rootElem.appendChild(this._contentElem);

            this._rootElem.appendChild(this._footerElem);
        }
        return contentProm;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onShutdown() {
        this._shutdown();
    }
    _onResizeEvent(/*width, height*/) {
        this._terminal.resize();
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    _renderContent() {
        let termRenderProm = this._terminal.renderer.render();
        if (!this._contentElem) {
            this._contentElem = document.createElement("package-editor-export-content-gl");
            this._contentElem.appendChild(this._terminal.renderer.rootElement);
        }
        return termRenderProm;
    }
    _renderFooter() {
        if (!this._footerElem) {
            this._footerElem = document.createElement("package-editor-export-footer-gl");
            this.exportBtn = new ButtonControl({
                label: "Export Package"
            });
            this.exportBtn.renderer.rootElement.classList.add("package_export", "active");
            this.exportBtn.on("UserClick", () => {
                this._terminal.clear();
                this._model.exportPackage({
                    Success: (/*results*/) => {
                        this._terminal.write("Export Completed!");
                    },
                    Progress: (msg) => {
                        this._terminal.writeln(msg);
                    },
                    Failure: (error) => {
                        this._terminal.writeln("");
                        this._terminal.writelnError("***Export Failed***");
                        this._terminal.writelnError(error.error);
                    }
                });
            });
            this._footerElem.appendChild(this.exportBtn.renderer.rootElement);
        }
    }
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = PackageEditorExportTabRenderer;
